import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import LogRocket from 'logrocket';
import { of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import * as googleSearchActions from './google-search.actions';

export interface GoogleSearchStateModel {
	connected: boolean;
	error: string;
}
@UntilDestroy()
@State<GoogleSearchStateModel>({
	name: 'googleSearch',
	defaults: {
		connected: false,
		error: '',
	},
})
@Injectable()
export class GoogleSearchState {
	constructor(private httpClient: HttpClient) {}

	@Selector([GoogleSearchState])
	static connected(state: GoogleSearchStateModel) {
		return state?.connected;
	}

	@Action(googleSearchActions.Connect)
	connect(sc: StateContext<GoogleSearchStateModel>) {
		this.httpClient
			.jsonp(
				`https://maps.googleapis.com/maps/api/js?key=${environment.firebase.apiKey}&libraries=places`,
				'callback',
			)
			.pipe(
				untilDestroyed(this),
				map(() => {
					sc.patchState({ connected: true });

					return true;
				}),
				catchError((err) => {
					LogRocket.log('Error connecting to Google Maps', err);
					console.log('google search connection error!', err);
					sc.patchState({ error: err });

					return of(false);
				}),
			)
			.subscribe();
	}
}
